import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Switch,
  Route,
} from 'react-router-dom';

import { isLoggedIn } from './api/Auth';

import AdminPanelSidebar from './components/AdminPanel/Sidebar';
import ConfirmationModal from './components/ConfirmationModal';
import FlashMessages from './components/FlashMessages';
import LoadingMain from './components/LoadingMain';

import AdminPanelDashboard from './containers/AdminPanel/Dashboard';
import AdminPanelAccounts from './containers/AdminPanel/Accounts';
import AdminPanelChangelog from './containers/AdminPanel/Changelog';
import AdminPanelOnlineUsers from './containers/AdminPanel/OnlineUsers';
import AdminPanelPricing from './containers/AdminPanel/Pricing';
import NoMatch from './containers/NoMatch';

import ProfileEdit from './containers/ProfileEdit';

import { resizeSplitContentContainer } from './helpers/App';

class AppAdminContent extends Component {
  // eslint-disable-next-line class-methods-use-this
  componentDidMount() {
    window.addEventListener('resize', resizeSplitContentContainer);
  }

  // eslint-disable-next-line class-methods-use-this
  componentWillUnmount() {
    window.removeEventListener('resize', resizeSplitContentContainer);
  }

  render() {
    const {
      profile,
      history,
    } = this.props;

    if (!profile) {
      return (
        <LoadingMain />
      );
    }

    const params = (new URL(document.location)).searchParams;
    if (!isLoggedIn()) {
      let loginUrl = '/login';
      loginUrl = `${loginUrl}?${params.toString()}`;
      history.push(loginUrl);
    }

    return (
      <div>
        <div className="layout layout-nav-side">
          <AdminPanelSidebar />
          <div className="main-container">
            <Switch>
              <Route exact path="/" component={AdminPanelDashboard} />
              <Route exact path="/changelog" component={AdminPanelChangelog} />
              <Route exact path="/accounts" component={AdminPanelAccounts} />
              <Route exact path="/online" component={AdminPanelOnlineUsers} />
              <Route exact path="/pricing" component={AdminPanelPricing} />
              <Route exact path="/profile/edit" component={ProfileEdit} />
              <Route component={NoMatch} />
            </Switch>
            <ConfirmationModal />
          </div>
          <FlashMessages />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.Auth.profile,
  selectedFiles: state.Files.selectedFiles,
  selectedCollections: state.Collections.selectedCollections,
  fileModalOpen: state.Files.fileModalOpen,
  uploadModal: state.Files.uploadModal,
});

AppAdminContent.propTypes = {
  history: PropTypes.object.isRequired,
  profile: PropTypes.object,
};

AppAdminContent.defaultProps = {
  profile: null,
};

export default connect(mapStateToProps)(AppAdminContent);
